import React, {useState} from 'react'
import './index.scss'
import {useSelector} from "react-redux";
import {convertToHoursFormat} from "../../../Global/Api/Shared/useFormatTimeMinutes";
import AddLineItems from "../../Modals/AddLineItems";

export default function LineItems() {
    const [showAddLine, setShowAddLine] = useState(false);
  const { activeJob } = useSelector((state) => state.rootReducer.jobsSlice);
  const accountData = useSelector(
    (state) => state.rootReducer.techsbookSlice.userData
  );
  const sumMinutesInItems = () => {
    const totalMinutes = activeJob?.items?.reduce((total, item) => {
        return total + item?.time * item?.qty;
    }, 0);

    return convertToHoursFormat(totalMinutes);
  };

  const openAddLineItemsModal = () => {
      setShowAddLine(true)
  }

  return (
      <>
          {
              showAddLine ? <AddLineItems setShowAddLine={setShowAddLine} currentJob={activeJob}/> : null
          }
          <div className="jobLineItems">
              <div className="jobLineItems_heading">
                  <p className="jobLineItems__title">Line items</p>
                  {
                      activeJob?.status === 'pending' ||
                      activeJob?.status === 'accepted' ||
                      activeJob?.status === 'inprogress_site' ||
                      activeJob?.status === 'inprogress_way' && activeJob?.payment_method === "card" ?
                      <button onClick={openAddLineItemsModal} className="jobLineItems__add-btn">
                          <img src="/assets/icons/add-line-item-icon.svg" alt=""/>
                          Add line item
                      </button> : null
                  }
              </div>
              <div className="jobLineItems__table">
                  <div className="jobLineItems__head">
                      <div className="jobLineItems__head-item">Product</div>
                      <div className="jobLineItems__head-item">Type of service</div>
                      <div className="jobLineItems__head-item">Price</div>
                      <div className="jobLineItems__head-item">Approximate time</div>
                      <div className="jobLineItems__head-item">Qty</div>
                  </div>
                  <div className="jobLineItems__list">
                      {
                          activeJob?.items?.map(item => (
                              <div key={item?.id}
                                   className={`jobLineItems__item ${item?.qty === item?.completed_qty && 'jobLineItems__item_completed'}`}>
                                  <div className="jobLineItems__item-text">{item?.product}</div>
                                  <div className="jobLineItems__item-text">{item?.product_service}</div>
                                  <div
                                      className="jobLineItems__item-text">{accountData?.country_currency_sign} {item?.price}</div>
                                  <div className="jobLineItems__item-text">{convertToHoursFormat(item?.time)} hrs</div>
                                  <div className="jobLineItems__item-text">{item?.qty}</div>
                              </div>
                          ))
                      }
                  </div>
              </div>
              <div className="jobLineItems__bottom">
                  <div className="jobLineItems__total">
                      Line items: <span>{activeJob?.items?.length}</span>
                  </div>
                  <div className="jobLineItems__hours">
                      Total: <span>{sumMinutesInItems()} hrs</span>
                  </div>
              </div>
          </div>
      </>
  )
}
